
export const helpFermVolTemp = 'Levain and dough volume increase times are a rough estimate for planning purposes.\n' +
        'Use your judgement by look and feel for signs of desired fermentation.\n\n' +
        'Variations in grain type, milling, starter health, and other factors influence the maturation time. ' +
        'For example, starters fed with fresh milled flour ferment more quickly and with different visible signs of maturity.\n\n' +
        'Projections were derived from volume gains measured with various seed ratios, temps and hydration levels. ' +
        'Levain can be ready to use at 85% to 100%.\n' +
        'Main dough is often fermented to a 45-50% volume increase, depending on flour and hydration.'

export const helpWeightButtons = 'The "Convert to %" button converts a copy of the Weight formula to a scalable Bakers formula and renders it in the %Bakers screen.\n' +
        'You can save either or both the Weight and Bakers formulas as long as you use separate names.'

